const BUSINESS_TYPES = [
  {
    label: "Agricultural Merchant / Farm Store",
    value: "Agricultural Merchant / Farm Store",
    id: "agricultural_merchant_farm_store",
  },
  {
    label: "Animal Shelter / Charity",
    value: "Animal Shelter / Charity",
    id: "animal_shelter_charity",
  },
  {
    label: "Backgrounder Lot",
    value: "Backgrounder Lot",
    id: "backgrounder_lot",
  },
  {
    label: "Beef Producer",
    value: "Beef Producer",
    id: "beef_producer",
  },
  { label: "Broilers", value: "Broilers", id: "broilers" },
  {
    label: "Buying Group",
    value: "Buying Group",
    id: "buying_group",
  },
  {
    label: "Calf Production",
    value: "Calf Production",
    id: "calf_production",
  },
  {
    label: "Calf Ranch/Developer",
    value: "Calf Ranch/Developer",
    id: "calf_ranch_developer",
  },
  { label: "Cattle Buyer", value: "Cattle Buyer", id: "cattle_buyer" },
  {
    label: "Contract Grower",
    value: "Contract Grower",
    id: "contract_grower",
  },
  { label: "Cooperative", value: "Cooperative", id: "cooperative" },
  {
    label: "Kurumsal Ofis",
    value: "Corporate Office",
    id: "corporate_office",
  },
  {
    label: "Cow/Calf Operation",
    value: "Cow/Calf Operation",
    id: "cow_calf_operation",
  },
  {
    label: "Dairy Production",
    value: "Dairy Production",
    id: "dairy_production",
  },
  {
    label: "Distributor / Agent",
    value: "Distributor / Agent",
    id: "distributor_agent",
  },
  { label: "Feed Mill", value: "Feed Mill", id: "feed_mill" },
  { label: "Feedyard", value: "Feedyard", id: "feedyard" },
  {
    label: "Grower/Growyard",
    value: "Grower/Growyard",
    id: "grower_growyard",
  },
  { label: "Hatchery", value: "Hatchery", id: "hatchery" },
  {
    label: "Heifer Production",
    value: "Heifer Production",
    id: "heifer_production",
  },
  {
    label: "Layer Integration",
    value: "Layer Integration",
    id: "layer_integration",
  },
  { label: "Layers", value: "Layers", id: "layers" },
  { label: "Media", value: "Media", id: "media" },
  {
    label: "Milk Cooperative/Buyer",
    value: "Milk Cooperative/Buyer",
    id: "milk_cooperative_buyer",
  },
  {
    label: "Mixed/Other Producer",
    value: "Mixed/Other Producer",
    id: "mixed_other_producer",
  },
  {
    label: "Nutrient Supplier",
    value: "Nutrient Supplier",
    id: "nutrient_supplier",
  },
  {
    label: "Packer/Processor",
    value: "Packer/Processor",
    id: "packer_processor",
  },
  {
    label: "Pet Retail Outlet",
    value: "Pet Retail Outlet",
    id: "pet_retail_outlet",
  },
  { label: "Pharmacy", value: "Pharmacy", id: "pharmacy" },
  {
    label: "Poultry Breeder",
    value: "Poultry Breeder",
    id: "poultry_breeder",
  },
  {
    label: "Poultry Integrator",
    value: "Poultry Integrator",
    id: "poultry_integrator",
  },
  { label: "Sheep Producer", value: "Sheep Producer", id: "sheep_producer" },
  {
    label: "Stocker Operation",
    value: "Stocker Operation",
    id: "stocker_operation",
  },
  {
    label: "Stockyard/Salebarn",
    value: "Stockyard/Salebarn",
    id: "stockyard_salebarn",
  },
  { label: "Swine Producer", value: "Swine Producer", id: "swine_producer" },
  { label: "Turkeys", value: "Turkeys", id: "turkeys" },
  {
    label: "University / Education",
    value: "University / Education",
    id: "university_education",
  },
  {
    label: "Veteriner Kliniği",
    value: "Veterinary Practice",
    id: "veterinary_practice",
  },
  {
    label: "Wholesaler / Retailer",
    value: "Wholesaler / Retailer",
    id: "wholesaler_retailer",
  },
  { label: "Wool Buyer", value: "Wool Buyer", id: "wool_buyer" },
];

const FIELDS = {
  common: {
    errors: {
      required: "Zorunlu",
    },
  },
  salutation: {
    label: "Hitap şekli",
    placeholder: "Hitap şeklini seçin",
    errors: {
      required: "Hitap şekli gereklidir",
      invalid: "Lütfen geçerli bir hitap şekli seçin",
    },
  },
  firstName: {
    label: "Ad",
    placeholder: "Matti",
    errors: {
      required: "Ad zorunludur",
      minLength: "Etunimen on oltava en az 2 karakter",
      maxLength: "Etunimen on oltava en fazla 50 karakter",
    },
  },
  lastName: {
    label: "Soyad",
    placeholder: "Meikäläinen",
    errors: {
      required: "Soyad zorunludur",
      minLength: "Sukunimen on oltava en az 2 karakter",
      maxLength: "Sukunimen on oltava en fazla 50 karakter",
    },
  },
  email: {
    label: "E-posta",
    placeholder: "ahmet.yilmaz@ornek.com",
    description:
      "Lütfen kişisel e-posta adresinizi girin, paylaşılan e-posta adresi değil.",
    prefixWarningTitle: "Paylaşılan Posta Kutusu Tespit Edildi",
    prefixWarningDescription:
      "Daha iyi ve kişiselleştirilmiş bir deneyim için kişisel bir e-posta adresi kullanmanızı öneririz",
    errors: {
      required: "E-posta gereklidir",
      invalidEmail: "Lütfen geçerli bir e-posta adresi girin",
      emailAssociatedWithYourAccount:
        "E-postaosoitteesi on liitetty tilillesi, eikä sitä voi muuttaa.",
    },
  },
  confirmEmail: {
    label: "E-postayı Onayla",
    placeholder: "ahmet.yilmaz@ornek.com",
    errors: {
      required: "E-posta onayı gereklidir",
      invalidEmail: "Lütfen geçerli bir e-posta adresi girin",
      emailMatchError: "E-posta adresleri eşleşmiyor",
    },
  },
  password: {
    label: "Şifre",
    placeholder: "Şifrenizi girin",
    errors: {
      required: "Şifre gereklidir",
    },
  },
  confirmPassword: {
    label: "Şifreyi Onayla",
    placeholder: "Şifrenizi onaylayın",
    errors: {
      required: "Şifre onayı gereklidir",
      passwordMatchError: "Şifreler eşleşmiyor",
    },
  },
  addressLine1: {
    label: "Adres satırı 1",
    placeholder: "Örnek Sokak 123",
    errors: {
      required: "Adres satırı 1 gereklidir",
      minLength: "Adres satırı 1 en az 5 karakter olmalıdır",
      maxLength: "Adres satırı 1 en fazla 100 karakter olmalıdır",
    },
  },
  addressLine2: {
    label: "Adres satırı 2",
    placeholder: "Daire 4B",
    errors: {
      required: "Adres satırı 2 gereklidir",
      maxLength: "Adres satırı 2 en fazla 100 karakter olmalıdır",
    },
  },
  city: {
    label: "Şehir / İlçe",
    placeholder: "İstanbul",
    errors: {
      required: "Şehir / İlçe gereklidir",
      minLength: "Şehir / İlçe en az 2 karakter olmalıdır",
      maxLength: "Şehir / İlçe en fazla 50 karakter olmalıdır",
    },
  },
  country: {
    label: "Ülke",
    placeholder: "Ülke Seçin",
    errors: {
      required: "Ülke gereklidir",
      invalid: "Lütfen geçerli bir ülke seçin",
    },
  },
  state: {
    label: "Eyalet",
    placeholder: "Eyalet seçin",
    errors: {
      required: "Eyalet gereklidir",
      invalid: "Lütfen geçerli bir eyalet seçin",
    },
  },
  jurisdiction: {
    label: "Lisans Yetki Alanı",
    placeholder: "Lisans Yetki Alanını Seçin",
    errors: {
      required: "Lisans Yetki Alanı gereklidir",
      invalid: "Lütfen geçerli bir yetki alanı seçin",
    },
  },
  zipCode: {
    label: "Posta kodu",
    placeholder: "34000",
    errors: {
      required: "Posta kodu gereklidir",
      invalid: "Lütfen geçerli bir posta kodu girin",
    },
  },
  role: {
    label: "Rol",
    placeholder: "Rolünüzü seçin",
    errors: {
      required: "Lütfen rolünüzü seçin",
      invalid: "Lütfen geçerli bir rol seçin",
    },
  },
  businessType: {
    label: "İşletme Türü",
    placeholder: "İşletme türünü seçin",
    errors: {
      required: "İşletme Türü gereklidir",
      invalid: "Lütfen geçerli bir işletme türü seçin",
    },
  },
  businessName: {
    label: "İşletme Adı",
    placeholder: "İşletme adını girin",
    errors: {
      required: "İşletme adı gereklidir",
      minLength: "İşletme adı en az 2 karakter olmalıdır",
      maxLength: "İşletme adı en fazla 100 karakter olmalıdır",
    },
  },
  businessSearch: {
    label: "İşletme Arama:",
    addNewAccount: "Yeni İşletme Hesabı Ekle",
    canNotFindBusiness: "İşletmenizi bulamıyor musunuz?",
    guideline:
      "Lütfen posta kodunuzu girin, ardından aşağıdaki listeden seçin.",
    guidelineForNameSearch:
      "Lütfen işletmenin tam adını girin, ardından listeden seçin.",
    placeholder: "Nerede çalışıyorsunuz?",
    noResults: "Sonuç bulunamadı",
    searching: "Aranıyor...",
    selectedBusinessHeading: "Seçilen İşletme:",
    selectedBusinessNotCorrect: "Doğru değil mi?",
    selectedBusinessTryAgain: "Tekrar dene",
    selectedBusinessDismiss: "İşletmeyi kapat",
    resultsFound: {
      singular: "1 işletme bulundu",
      plural: "Birden fazla işletme bulundu",
    },
    errors: {
      network:
        "İşletme Arama Hizmetine bağlanırken sorun yaşıyoruz. Lütfen daha sonra tekrar deneyin.",
    },
  },
  explicitConsent: {
    label:
      "Bu kutuyu işaretleyerek Elanco'nun Kullanım Koşullarını kabul ediyorum ve Elanco'nun kişisel bilgilerimi Elanco'nun Gizlilik Bildirimine uygun olarak toplayıp işleyeceğini onaylıyorum",
    errors: {
      required: "E-posta onayı gereklidir",
    },
  },
  explicitSmsConsent: {
    label:
      "Bu kutuyu işaretleyerek Elanco'dan SMS/kısa mesaj yoluyla pazarlama iletişimleri almayı kabul ediyorum.",
    errors: {
      required: "SMS onayı gereklidir",
    },
  },
  telephone: {
    label: "Kişisel Telefon",
    placeholder: "Kişisel telefon numaranızı girin",
    dialCodeLabel: "Kod",
    dialCodePlaceholder: "Ülke ara…",
    errors: {
      invalid: "Lütfen geçerli bir telefon numarası girin.",
    },
  },
  businessTelephone: {
    label: "İşletme Telefonu",
    placeholder: "İşletme telefon numarasını girin",
    dialCodeLabel: "Kod",
    dialCodePlaceholder: "Ülke ara…",
    errors: {
      invalid: "Lütfen geçerli bir telefon numarası girin.",
    },
  },
  professionalNumber: {
    label: "Profesyonel Numara",
    placeholder: "1234567",
    errors: {
      required: "Lütfen profesyonel numarayı girin",
      maxLength: "Girdi karakter sınırını aşıyor",
    },
  },
  addressSearch: {
    errors: {
      required: "Bu alan zorunludur",
    },
  },
  businessSearchField: {
    errors: {
      required: "Bu alan zorunludur",
    },
  },
  checkbox: {
    errors: {
      required: "Bu alan zorunludur",
    },
  },
  checkboxGroup: {
    errors: {
      required: "Bu alan zorunludur",
    },
  },
  combobox: {
    errors: {
      required: "Bu alan zorunludur",
    },
  },
  datePicker: {
    errors: {
      required: "Bu alan zorunludur",
    },
  },
  dateRange: {
    errors: {
      required: "Bu alan zorunludur",
    },
  },
  dateTime: {
    errors: {
      required: "Bu alan zorunludur",
    },
  },
  emailField: {
    errors: {
      required: "Bu alan zorunludur",
    },
  },
  fileInput: {
    errors: {
      required: "Lütfen bir dosya seçin",
    },
  },
  number: {
    errors: {
      required: "Lütfen bir sayı girin",
      minValue: "Lütfen minimum değerden daha yüksek bir değer girin",
      maxValue: "Lütfen maksimum değerden daha düşük bir değer girin",
    },
  },
  passwordField: {
    errors: {
      required: "Bu alan zorunludur",
    },
  },
  rangeSlider: {
    errors: {
      required: "Bu alan zorunludur",
    },
  },
  select: {
    errors: {
      required: "Bu alan zorunludur",
    },
  },
  telephoneField: {
    errors: {
      required: "Lütfen sadece rakamları girin",
      invalidTelephone: "Lütfen geçerli bir telefon numarası girin",
      invalidFormat: "Geçersiz numara formatı",
    },
  },
  text: {
    errors: {
      required:
        "Lütfen sadece harfleri (A-Z), rakamları (0-9) kullanın ve sembol kullanmayın",
      maxLength: "Girdi karakter sınırını aşıyor",
      minLength: "Girdi en az 2 karakter olmalıdır",
    },
  },
  textarea: {
    characters: "karakter",
  },
  time: {
    errors: {
      required: "Bu alan zorunludur",
    },
  },
  form: {
    errors: {
      generic:
        "Formunuzu gönderirken bir hatayla karşılaştık. Lütfen tekrar deneyin.",
      reportAnIssue: "Lütfen bir sorun bildirin.",
      configuration: "Yapılandırma Hatası",
      noFormQuestionsAvailable: "Form soruları mevcut değil.",
      formComponentLoad:
        "Desteklenmeyen bir alan nedeniyle form bileşeni yüklenemedi.",
      code: "Kod",
      type: "Tür",
      missingRequiredFields:
        "Bu formda gerekli alanlar (E-posta ve/veya Onay) eksik. Form yapılandırmasını düzeltmek için lütfen bir yöneticiyle iletişime geçin.",
    },
  },
};

const ROLES = [
  { value: "Academic", label: "Academic", id: "academic" },
  {
    value: "Animal Welfare - Other",
    label: "Animal Welfare - Other",
    id: "animal_welfare_other",
  },
  {
    value: "Animal Welfare - Retail Staff",
    label: "Animal Welfare - Retail Staff",
    id: "animal_welfare_retail_staff",
  },
  {
    value: "Animal Welfare - Vet",
    label: "Hayvan Refahı - Veteriner",
    id: "animal_welfare_vet",
  },
  {
    value: "Animal Welfare - Vet Nurse",
    label: "Animal Welfare - Vet Nurse",
    id: "animal_welfare_vet_nurse",
  },
  {
    value: "Animal Welfare - Volunteer",
    label: "Animal Welfare - Volunteer",
    id: "animal_welfare_volunteer",
  },
  {
    value: "Beef / Feedlot Extension",
    label: "Beef / Feedlot Extension",
    id: "beef_feedlot_extension",
  },
  {
    value: "Beef Producer",
    label: "Beef Producer",
    id: "beef_producer",
  },
  { value: "Breeder", label: "Breeder", id: "breeder" },
  {
    value: "Business Administrator / Receptionist",
    label: "Business Administrator / Receptionist",
    id: "business_administrator_receptionist",
  },
  {
    value: "Business Owner / Partner",
    label: "Business Owner / Partner",
    id: "business_owner_partner",
  },
  { value: "Clinic Buyer", label: "Clinic Buyer", id: "clinic_buyer" },
  {
    value: "Consulting Nutritionist",
    label: "Consulting Nutritionist",
    id: "consulting_nutritionist",
  },
  {
    value: "Corporate Employee Non DVM",
    label: "Corporate Veterinary Employee (non-hospital)",
    id: "corporate_employee_non_dvm",
  },
  {
    value: "Dairy Producer",
    label: "Dairy Producer",
    id: "dairy_producer",
  },
  { value: "Distributor", label: "Distributor", id: "distributor" },
  {
    value: "Distributor Rep, Field Based",
    label: "Distributor Rep, Field Based",
    id: "distributor_rep_field_based",
  },
  {
    value: "Distributor Rep, Inside",
    label: "Distributor Rep, Inside",
    id: "distributor_rep_inside",
  },
  {
    value: "Educational Institution - Highschool Student",
    label: "Educational Institute - Highschool Student",
    id: "educational_institution_highschool_student",
  },
  {
    value: "Educational Institution - TAFE Student",
    label: "Educational Institute - TAFE Student",
    id: "educational_institution_tafe_student",
  },
  {
    value: "Educational Institution - University Student",
    label: "Educational Institute - University Student",
    id: "educational_institution_university_student",
  },
  { value: "Groomer", label: "Groomer", id: "groomer" },
  {
    value: "Marketing Associate",
    label: "Marketing Associate",
    id: "marketing_associate",
  },
  {
    value: "Medical / Clinic Director",
    label: "Medical/Clinic Director",
    id: "medical_clinic_director",
  },
  {
    value: "Nutrition / Feed Sales",
    label: "Nutrition / Feed Sales",
    id: "nutrition_feed_sales",
  },
  {
    value: "Nutritional Professional",
    label: "Nutritional Professional",
    id: "nutritional_professional",
  },
  { value: "Nutritionist", label: "Nutritionist", id: "nutritionist" },
  {
    value: "Office / Practice Manager",
    label: "Office/Practice Manager",
    id: "office_practice_manager",
  },
  { value: "OTC Retailer", label: "OTC Retailer", id: "otc_retailer" },
  { value: "Pharmacist", label: "Pharmacist", id: "pharmacist" },
  {
    value: "Pharmacy - Staff",
    label: "Pharmacy - Staff",
    id: "pharmacy_staff",
  },
  { value: "Pig Producer", label: "Pig Producer", id: "pig_producer" },
  {
    value: "Poultry Producer",
    label: "Poultry Producer",
    id: "poultry_producer",
  },
  {
    value: "Practice Owner, Non DVM",
    label: "Practice Owner, Non DVM",
    id: "practice_owner_non_dvm",
  },
  {
    value: "Purchasing Agent",
    label: "Purchasing Agent",
    id: "purchasing_agent",
  },
  {
    value: "Receptionist / Client Service",
    label: "Receptionist/Client Service",
    id: "receptionist_client_service",
  },
  {
    value: "Reseller Store - Staff",
    label: "Reseller Store - Staff",
    id: "reseller_store_staff",
  },
  {
    value: "Producer - Mixed/Other",
    label: "Üretici - Karışık/Diğer",
    id: "producer_mixed_other",
  },
  { value: "Retail Staff", label: "Retail Staff", id: "retail_staff" },
  {
    value: "Retail Store Manager",
    label: "Retail Store Manager",
    id: "retail_store_manager",
  },
  {
    value: "Retailer",
    label: "Perakendeci",
    id: "retailer",
  },
  {
    value: "Sheep Producer",
    label: "Koyun Üreticisi",
    id: "sheep_producer",
  },
  { value: "SQP", label: "RAMA / SQP", id: "sqp" },
  { value: "Student", label: "Student", id: "student" },
  { value: "Student RAMA", label: "Student RAMA", id: "student_rama" },
  {
    value: "Tierarzt/ Tierärztin",
    label: "Veteriner",
    id: "tierarzt_tierarztin",
  },
  { value: "Trainer", label: "Trainer", id: "trainer" },
  { value: "Veterinarian", label: "Veteriner", id: "veterinarian" },
  {
    value: "Veterinarian, Practice Owner",
    label: "Veteriner, Klinik Sahibi",
    id: "veterinarian_practice_owner",
  },
  {
    value: "Veterinary Assistant",
    label: "Veteriner Asistanı",
    id: "veterinary_assistant",
  },
  {
    value: "Veterinary Nurse",
    label: "Veterinary Nurse",
    id: "veterinary_nurse",
  },
  {
    value: "Veterinary Practice - Other",
    label: "Veteriner Kliniği - Diğer",
    id: "veterinary_practice_other",
  },
  {
    value: "Veterinary Practice - Vet",
    label: "Veteriner Kliniği - Veteriner",
    id: "veterinary_practice_vet",
  },
  {
    value: "Veterinary Practice - Vet Nurse",
    label: "Veteriner Kliniği - Veteriner Hemşiresi",
    id: "veterinary_practice_vet_nurse",
  },
  {
    value: "Veterinary Specialist",
    label: "Veteriner Uzmanı",
    id: "veterinary_specialist",
  },
  {
    value: "Veterinary Student",
    label: "Veterinary Student",
    id: "veterinary_student",
  },
  {
    value: "Veterinary Surgeon",
    label: "Veteriner",
    id: "veterinary_surgeon",
  },
  {
    value: "Veterinary Technician",
    label: "Veterinary Technician",
    id: "veterinary_technician",
  },
  { value: "Wholesaler", label: "Wholesaler", id: "wholesaler" },
];

const SALUTATIONS = [
  {
    label: "Dr.",
    value: "Dr.",
    id: "dr",
  },
  {
    label: "Bay",
    value: "M.",
    id: "m",
  },
  {
    label: "Miss",
    value: "Miss",
    id: "miss",
  },
  {
    label: "Bay",
    value: "Mr.",
    id: "mr",
  },
  {
    label: "Bayan",
    value: "Mrs.",
    id: "mrs",
  },
  {
    label: "Bayan",
    value: "Ms.",
    id: "ms",
  },
  {
    label: "Mx.",
    value: "Mx.",
    id: "mx",
  },
  {
    label: "Profesör",
    value: "Professor",
    id: "professor",
  },
];

export { BUSINESS_TYPES, FIELDS, ROLES, SALUTATIONS };
